module.exports = __webpack_public_path__ + "static/media/refresh-2.0e33ecb9.svg";